import styled from "styled-components";
import { Typography } from "@bracket/ui";

interface DisabledSectionProps {
  disabled?: boolean;
  children: React.ReactNode;
  label?: string;
}

const Container = styled.div<{ disabled?: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
`;

const BlurOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  cursor: not-allowed;
`;

const ChildrenWrapper = styled.div<{ disabled?: boolean }>`
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
`;

export const DisabledSection: React.FC<DisabledSectionProps> = ({
  disabled,
  children,
  label = "Not available yet",
}) => {
  if (!disabled) {
    return <>{children}</>;
  }

  return (
    <Container disabled={disabled}>
      <ChildrenWrapper disabled={disabled}>{children}</ChildrenWrapper>
      <BlurOverlay>
        <Typography variant="h5" color="var(--text-paragraph)">
          {label}
        </Typography>
      </BlurOverlay>
    </Container>
  );
};
